import { TransientAccessCredEventNames } from '../../constants/transient_access_cred_constants';
import { ClearTransientAccessCredCommand } from '../../commands/clear_transient_access_cred_command';
import { CommunicatorService } from 'ui-ng-component-communicator';
import { HILForm } from '../../../interfaces/scheduler_interfaces';

class TransientAccessCredDialog {
  private closeDialogBound = this.closeDialog.bind(this);
  private openDialogBound = this.openDialog.bind(this);

  constructor(
    private ngComponentCommunicatorService: CommunicatorService,
    private $element: ng.IAugmentedJQuery,
    private clearTransientAccessCredCommand: ClearTransientAccessCredCommand
  ) {}

  $onInit() {
    this.clearAccessCred();
    this.ngComponentCommunicatorService.subscribe(
      TransientAccessCredEventNames.CRED_FORM_ENTRY_CANCELLED,
      this.closeDialogBound
    );
    this.ngComponentCommunicatorService.subscribe(TransientAccessCredEventNames.NEW_CRED_SAVED, this.closeDialogBound);
    this.ngComponentCommunicatorService.subscribe(TransientAccessCredEventNames.OPEN_CRED_DIALOG, this.openDialogBound);
  }

  $onDestroy() {
    this.ngComponentCommunicatorService.release(
      TransientAccessCredEventNames.CRED_FORM_ENTRY_CANCELLED,
      this.closeDialogBound
    );
    this.ngComponentCommunicatorService.release(TransientAccessCredEventNames.NEW_CRED_SAVED, this.closeDialogBound);
    this.ngComponentCommunicatorService.release(TransientAccessCredEventNames.OPEN_CRED_DIALOG, this.openDialogBound);
  }

  openDialog() {
    const dialog = this.$element[0].querySelector('hi-dialog');
    if (!dialog) {
      return;
    }
    const form = dialog.querySelector('hi-form') as HILForm;
    if (form) {
      form.reset();
    }
    dialog.setAttribute('opened', 'true');
  }

  closeDialog() {
    (this.$element[0].querySelector('hi-dialog') as HTMLElement).removeAttribute('opened');
  }

  clearAccessCred() {
    return this.clearTransientAccessCredCommand().then(() =>
      this.ngComponentCommunicatorService.publish(TransientAccessCredEventNames.CRED_CLEARED)
    );
  }
}

angular.module('capability-ng-scheduler').component('transientAccessCredDialog', {
  templateUrl:
    'capability-ng-scheduler/src/prevent_transient_access/components/transient_access_cred_dialog/transient_access_cred_dialog.html',
  controller: TransientAccessCredDialog
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/prevent_transient_access/components/transient_access_cred_dialog/transient_access_cred_dialog.ts